var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup22X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54443 22.0298H0V10.864H7.54443V22.0298ZM0.723236 21.3047H6.84954V11.5891H0.723236V21.3047Z",
    fill: "#233A80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8057 22.03H10.2612V6.94116H17.8057V22.03ZM10.9845 21.3094H17.1108V7.66174H10.9845V21.3094Z",
    fill: "#233A80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 22.0297H20.2202V0H28.0664V22.0297ZM20.9724 21.3093H27.3437V0.720397H20.9724V21.3093Z",
    fill: "#233A80"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.738281,
    y: 11.5247,
    width: 6.64713,
    height: 10.34,
    fill: "#233A80"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3403,
    y: 7.09302,
    width: 7.3857,
    height: 14.7714,
    fill: "#233A80"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6797,
    y: 0.446045,
    width: 7.3857,
    height: 21.4185,
    fill: "#233A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22X);
export default __webpack_public_path__ + "static/media/Group22x.700840d02caaaae2dce90325cd7c4617.svg";
export { ForwardRef as ReactComponent };